import { Component, inject, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  ReactiveFormsModule,
  ValidationErrors,
  Validators,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';
import { DialogData } from '../../../../shared/models/dialog-data.model';
import { FORM_ERROR_MESSAGES } from '../../../dashboard/dialogs/add-website-dialog/add-website-dialog.const';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { InputField } from '../../../../shared/components/input-field/input-field';

@Component({
  selector: 'app-rename-main-dialog',
  imports: [
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    InputField,
    MatCheckboxModule,
  ],
  templateUrl: './rename-main-dialog.component.html',
  styleUrl: './rename-main-dialog.component.scss',
})
export class RenameMainDialogComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<RenameMainDialogComponent>);

  readonly data = inject<DialogData & { websiteId: number }>(MAT_DIALOG_DATA);

  private fb = inject(FormBuilder);

  readonly errors = FORM_ERROR_MESSAGES;

  form = this.fb.nonNullable.group({
    id: [0, [Validators.required]],
    newDomain: ['', [Validators.required, this.domainValidator]],
    excludeActions: [],
    dns: [true], // Utility control
    email: [true], // Utility control
  });

  ngOnInit(): void {
    this.form.controls.id.setValue(this.data.websiteId);
  }

  submit(): void {
    if (this.form.invalid) return;

    const { id, newDomain, dns, email } = this.form.getRawValue();
    const value = {
      id,
      newDomain,
      excludeActions: [dns ? '' : 'dns', email ? '' : 'email'].filter((action) => action),
    };
    this.dialogRef.close(value);
  }

  close(): void {
    this.dialogRef.close();
  }

  private domainValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    const isValid = !!value.match(/\w{3,}\.[a-z]{2,}/);
    return isValid ? null : { invalidDomain: true };
  }
}
